import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { ChangeOmaUserDetailsRequest, ChangeUserDetailsRequest } from '@vi-iot/client';

import { LANGUAGES } from '@store';
import { LanguageDetailsFormGroup } from './other-details.helper';
import { SupportedCountriesService } from 'src/app/shared/services/supported-countries.service';
import { MatTooltip } from '@angular/material/tooltip';
import { matTooltipSetter } from 'src/app/shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-other-details',
  templateUrl: './other-details.component.html',
  styleUrls: ['./other-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OtherDetailsComponent implements OnInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }
  formGroup: FormGroup<LanguageDetailsFormGroup>;
  languages = LANGUAGES;

  @Input() details: {
    language: string;
  };
  @Input() workCountryCode: string;
  @Input() isOmaUser: boolean;

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  @Output() save: EventEmitter<ChangeUserDetailsRequest> = new EventEmitter<
    ChangeUserDetailsRequest
  >();

  @Output() omaSave: EventEmitter<ChangeOmaUserDetailsRequest> = new EventEmitter<
    ChangeUserDetailsRequest
  >();

  supportedCountries: string[];

  constructor(private supportedCountriesService: SupportedCountriesService) {}

  ngOnInit(): void {
    const language = this.parseLanguageCode(this.details.language);
    const country = this.parseCountryCode(this.workCountryCode);

    this.formGroup = new FormGroup<LanguageDetailsFormGroup>({
      language: new FormControl<string>(language),
      workCountryCode: new FormControl<string>(country),
    });

    if (this.isOmaUser) {
      this.supportedCountries = this.supportedCountriesService
        .getUniqueSupportedCountriesSortedAlphabetically()
        .map((el) => el.countryCode);
    }
  }

  onCancel(): void {
    this.cancel.emit();
  }

  dispatchSave(): void {
    if (this.isOmaUser) {
      this.onOmaSave();
    } else {
      this.onSave();
    }
  }

  onSave(): void {
    this.save.emit({
      languageCode: this.formGroup.value.language,
    });
  }

  onOmaSave(): void {
    this.omaSave.emit({
      workCountryCode: this.formGroup.value.workCountryCode,
    });
  }

  private parseLanguageCode(language: string): string {
    if (language) {
      const locale = language.split('-');
      if (locale[0]) {
        return locale[0].toLowerCase();
      } else {
        return language;
      }
    }

    return '';
  }

  private parseCountryCode(code: string): string {
    if (code && code !== '-') {
      const parsed = code.split('-');

      return parsed[0].toLowerCase();
    }

    return '';
  }
}
